import React, { useEffect, useState } from "react";
import { AiOutlineInstagram } from "react-icons/ai";
import { AiOutlinePinterest } from "react-icons/ai";
import { AiOutlineTwitter } from "react-icons/ai";
import { AiOutlineTruck } from "react-icons/ai";
import { AiOutlineGithub } from "react-icons/ai";
import { IoLogoApple } from "react-icons/io";
import { BsCash } from "react-icons/bs";
import { FaDribbble, FaFacebookSquare, FaWhatsapp } from "react-icons/fa";
import { FaSnapchat, FaBasketballBall, FaGooglePlusG } from "react-icons/fa";
import { Link } from "react-router-dom";
export const Footer2 = () => {
  const [footerColor, setFooterColor] = useState("#000");
  const [footerTextColor, setFooterTextColor] = useState("#fff");
  const [font, setFont] = useState("");
  const [themeColor, setThemeColor] = useState("#708090");
  const [themeIconColor, setThemeIconColor] = useState("#708090");
  const [socialLinks, setSocialLinks] = useState({});
  const accessToken = sessionStorage.getItem("accessToken");
  const appName = sessionStorage.getItem("appName");

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setFooterColor(parsedStyle.footer_color);
      setFooterTextColor(parsedStyle.footer_text_color);
      setFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setSocialLinks({
        facebook: parsedStyle.facebook_link || "https://facebook.com",
        twitter: parsedStyle.twitter_link || "https://twitter.com",
        instagram: parsedStyle.instagram_link || "https://instagram.com",
        pinterest: parsedStyle.pinterest_link || "https://pinterest.com",
        linkedin: parsedStyle.linkedin_link || "https://linkedin.com",
        youtube: parsedStyle.youtube_link || "https://youtube.com",
        whatsapp: parsedStyle.whatsapp_link || "https://web.whatsapp.com/",
        appleStore:
          parsedStyle.apple_store_link ||
          "https://apps.apple.com/in/app/apple-store/id375380948?mt=8&mnid=sfo291LJq-dc_mtid_187079nc38483_pcrid_731945015408_pgrid_109516736059_pntwk_g_pchan__pexid_195442770243_ptid_kwd-12522920_&cid=aos-IN-kwgo-brand--slid-FER4pAmp--product-&mtid=187079nc38483&aosid=p238",
        playStore:
          parsedStyle.play_store_link ||
          "https://play.google.com/store/games?hl=en&pli=1",
        snapchat: parsedStyle.snapchat_link || "https://www.snapchat.com/",
        dribble: parsedStyle.dribble_link || "https://dribbble.com/",

      });
    }
  }, []);

  return (
    <div
      className={`${font}`}
      style={{ backgroundColor: footerColor, color: footerTextColor }}
    >
      <footer className="px-6 py-8 ">
        <div className="grid grid-cols-1 gap-8 mx-auto max-w-7xl md:grid-cols-3">
          {/* Customer Service */}
          <div>
            <h6 style={{ color: footerTextColor }}>CUSTOMER SERVICE</h6>
            <div className="grid mt-4 space-y-2">
              <Link className="text-decoration-none text-inherit" to="/contact">
                Contact Us
              </Link>
              {accessToken && (
                <Link
                  to={{
                    pathname: "/dashboard",
                  }}
                  state={{ page: "myorders" }}
                  className="text-inherit text-decoration-none "
                >
                  Track Order
                </Link>
              )}
              <Link className="text-decoration-none text-inherit" to="/faq">
                FAQ
              </Link>
            </div>
            {/* <div className="grid mt-4">
              <p className="flex text-sm ">
                {" "}
                <i className="mr-2">
                  <AiOutlineTruck
                    style={{
                      color: themeIconColor,
                    }}
                  />
                </i>{" "}
                15 Days Return Policy*
              </p>
              <p className="flex text-sm ">
                {" "}
                <i className="mr-2">
                  <BsCash
                    style={{
                      color: themeIconColor,
                    }}
                  />
                </i>{" "}
                Cash On Delivery*
              </p>
            </div> */}
          </div>

          {/* Company */}
          <div>
            <h6 style={{ color: footerTextColor }}>COMPANY</h6>
            <div className="grid mt-4 space-y-2">
              <Link className="text-decoration-none text-inherit" to="/aboutus">
                About Us
              </Link>
              <Link
                className="text-decoration-none text-inherit"
                to="/termsandcondition"
              >
                Terms and Conditions
              </Link>
              <Link
                className="text-decoration-none text-inherit"
                to="/privacyandpolicy"
              >
                Privacy Policy
              </Link>

            </div>

            <div className="flex flex-col mt-4 ">
              <h6
                className="mb-2 font-semibold "
                style={{
                  color: footerTextColor,
                }}
              >
                DOWNLOAD THE APP
              </h6>
              <div className="flex space-x-2">
                <a
                  href={socialLinks.appleStore}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="float-right h-10 w-15"
                    src="https://s.alicdn.com/@img/imgextra/i4/O1CN01i9Aj641atkjJJ9I6y_!!6000000003388-2-tps-396-132.png"
                    alt=""
                  />
                </a>
                <a
                  href={socialLinks.playStore}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="float-right h-10 w-15"
                    src="https://s.alicdn.com/@img/imgextra/i4/O1CN018KnDNq1JleFgkjLRq_!!6000000001069-2-tps-447-132.png"
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>

          {/* Connect With Us */}
          <div>
            <h6 style={{ color: footerTextColor }}>CONNECT WITH US</h6>
            <div className="flex flex-wrap gap-3 mt-4 text-xl">
              {socialLinks.facebook && (
                <a
                  href={socialLinks.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookSquare style={{ color: themeIconColor }} />
                </a>
              )}
              {socialLinks.instagram && (
                <a
                  href={socialLinks.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                >

                  <AiOutlineInstagram style={{ color: themeIconColor }} />
                </a>
              )}
              {socialLinks.pinterest && (
                <a
                  href={socialLinks.pinterest}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AiOutlinePinterest style={{ color: themeIconColor }} />
                </a>
              )}
              {socialLinks.twitter && (
                <a
                  href={socialLinks.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AiOutlineTwitter style={{ color: themeIconColor }} />
                </a>
              )}

              {socialLinks.appleStore && (
                <a
                  href={socialLinks.appleStore}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <IoLogoApple style={{ color: themeIconColor }} />
                </a>
              )}
              {socialLinks.appleStore && (
                <a
                  href={socialLinks.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp style={{ color: themeIconColor }} />
                </a>
              )}
              {socialLinks.snapchat && (
                <a
                  href={socialLinks.snapchat}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaSnapchat style={{ color: themeIconColor }} />
                </a>
              )}
              {socialLinks.dribble && (
                <a
                  href={socialLinks.dribble}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaBasketballBall style={{ color: themeIconColor }} />
                </a>
              )}
            </div>

            <div className="mt-5">
              <h6 className="font-semibold" style={{ color: footerTextColor }}>
                100% SECURE PAYMENT
              </h6>
              <div className="flex flex-wrap text-white">
                <img
                  className="w-10 h-10 m-2 bg-white rounded-sm"
                  src="https://cdn-icons-png.flaticon.com/128/6124/6124998.png"
                  alt="payment-1"
                />
                <img
                  className="w-10 h-10 m-2 bg-white rounded-sm"
                  src="https://cdn-icons-png.flaticon.com/128/825/825454.png"
                  alt="payment-2"
                />
                <img
                  className="w-10 h-10 m-2 bg-white rounded-sm"
                  src="https://cdn-icons-png.flaticon.com/128/179/179457.png"
                  alt="payment-3"
                />
                <img
                  className="w-10 h-10 m-2 bg-white rounded-sm"
                  src="https://cdn-icons-png.flaticon.com/128/14881/14881313.png"
                  alt="payment-4"
                />
                <img
                  className="w-10 h-10 m-2 bg-white rounded-sm"
                  src="https://cdn-icons-png.flaticon.com/128/714/714867.png"
                  alt="payment-5"
                />
              </div>
            </div>
          </div>




        </div>
      </footer>
    </div>
  );
};

export default Footer2;
